import { companyStateSelector } from "@store/workspace/workspace-slice";
import { plansCreationStateSelector } from "@store/plan-creation/plan-creation-slice";
import { useAppSelector } from "@store/store-helper";
import { PlanCreationModeProps } from "@custom-types/base-types";
import { isInternalCompanyType } from "@pages/workspace-profile/workspace-constants";
import { isProductionEnvironment } from "@utils/env-utils";
import { isUnusuallyLongSubscription } from "@utils/plan-duration";

/**
 * Whether the subscription about to be created lasts long enough that the user should confirm
 * the duration was not a mistake.
 */
export function useShouldConfirmLongDuration({
  creationMode,
}: PlanCreationModeProps): boolean {
  const {
    creationDates: { startDate, endDate },
    planSubject: { planSubscriberId },
  } = useAppSelector(plansCreationStateSelector);
  const { company } = useAppSelector(companyStateSelector);

  // Only workspace plans load their workspace, so any other subject counts as a customer
  const isInternalWorkspace =
    company?.id === planSubscriberId && isInternalCompanyType(company.type);

  return (
    // The confirmation only protects real customers, so dev and staging are left out
    isProductionEnvironment &&
    creationMode === "subscription" &&
    !isInternalWorkspace &&
    isUnusuallyLongSubscription({ startDate, endDate })
  );
}
